import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

const MenuFooterItem = ({ children, className, title }) => (
  <div className={cx('menu-footer-item', className)}>
    {title && <Label className="menu-footer-item__heading" message={title} />}
    {children}
  </div>
);

MenuFooterItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
};

export default MenuFooterItem;
